/* angular:styles/component:css;f9820be5d7ea411c47ac90455ddd4ee9908205e19171c57cff507d9557a054ce;/src/src/app/shared/components/formly/formly-field-range.ts */
ion-range.range-invalid::part(label) {
  color: var(--ion-color-danger);
}
.range-current-value {
  display: block;
  text-align: left;
  font-size: 0.8rem;
}
/*# sourceMappingURL=formly-field-range.css.map */
